import { useState, useEffect } from 'react';

const STORAGE_KEY = 'alldrop_theme';

function applyTheme(preference) {
  let resolved = preference;
  if (preference === 'auto') {
    resolved = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  document.documentElement.setAttribute('data-theme', resolved);
}

export function useTheme() {
  const [preference, setPreference] = useState(
    () => localStorage.getItem(STORAGE_KEY) || 'auto'
  );

  useEffect(() => {
    applyTheme(preference);

    if (preference !== 'auto') return;
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = () => applyTheme('auto');
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [preference]);

  const setTheme = (pref) => {
    localStorage.setItem(STORAGE_KEY, pref);
    setPreference(pref);
  };

  return { preference, setTheme };
}

// Применить тему сразу при загрузке (до первого рендера)
applyTheme(localStorage.getItem(STORAGE_KEY) || 'auto');
